<template>
  <email-form-modal
    v-if="value"
    :modal-id="modalId"
    title="Email Purchase Order"
    :initial-emails="[prefilledEmail]"
    :request="submitRequest"
    @success="(supplyOrder) => $emit('input', supplyOrder)"
  />
</template>

<script>
import EmailFormModal from '@/components/shared/EmailFormModal.vue';

export default {
  name: 'PurchaseOrderEmailModal',
  components: {
    EmailFormModal,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      modalId: 'purchase-order-email-modal',
      prefilledEmail: this.$store.getters.user.email,
      prefillRequestId: 0,
    };
  },
  computed: {
    vendorId() {
      return this.value?.vendor_id;
    },
  },
  watch: {
    vendorId: {
      immediate: true,
      handler() {
        this.loadPrefilledEmail();
      },
    },
  },
  methods: {
    async loadPrefilledEmail() {
      const fallbackEmail = this.$store.getters.user.email;
      this.prefilledEmail = fallbackEmail;

      const vendorId = this.vendorId;
      if (!vendorId) {
        return;
      }

      const requestId = ++this.prefillRequestId;
      try {
        const response = await this.$contactInfosAPI.getVendorsContactInfos(vendorId, {
          active: true,
          category: 'billing_email',
        });
        if (requestId !== this.prefillRequestId) {
          return;
        }
        this.prefilledEmail = response?.contactInfos?.[0]?.content || fallbackEmail;
      } catch (error) {
        //
      }
    },
    submitRequest(payload) {
      return this.$supplyOrdersAPI.emailPurchaseOrder(this.value.id, payload);
    },
  },
};
</script>
